<ion-fab horizontal="end" slot="fixed">
  <ion-fab-button (click)="toggleMapType()" color="light" size="small" class="tw:mr-0">
    <ion-icon name="layers-outline"></ion-icon>
  </ion-fab-button>
  <ng-content></ng-content>
</ion-fab>
